export default {"src":"/_next/static/media/picture_bold.a6703069.svg","height":24,"width":24};